<template>
  <div class="workflow-output-page">
    <!-- Modern Header matching Forms/Wiki style -->
    <div class="workflow-header">
      <div class="header-left">
        <router-link :to="{ name: 'Workflow' }" class="back-link">
          <i class="fa fa-arrow-left"></i> Back to Workflows
        </router-link>
        <h1 class="page-title">Workflow Output</h1>
      </div>
    </div>

    <ErrorDisplay/>

    <!-- Workflow Info Summary -->
    <div class="workflow-info-card" v-if="workflowOutput && workflowOutput.length > 0">
      <div class="info-item name-item">
        <span class="info-label"><i class="fa fa-sitemap"></i> Workflow Name</span>
        <span class="info-value">{{ workflowOutput[0].Name }}</span>
      </div>
      <div class="info-item trigger-item">
        <span class="info-label"><i class="fa fa-bolt"></i> Trigger</span>
        <span class="trigger-badge">{{ workflowOutput[0].TriggerOn }}</span>
      </div>
      <div class="info-item runs-item">
        <span class="info-label"><i class="fa fa-history"></i> Total Runs</span>
        <span class="info-value">{{ workflowOutput.length }}</span>
      </div>
    </div>

    <!-- Output Panel -->
    <div class="output-panel">
      <div class="panel-card">
        <div class="panel-header">
          <h5 class="section-title">
            <i class="fa fa-list-alt section-icon"></i>
            Execution History
          </h5>
        </div>

        <!-- Empty State -->
        <div class="empty-state" v-if="workflowOutput && workflowOutput.length === 0">
          <div class="empty-icon">
            <i class="fa fa-clock-o"></i>
          </div>
          <h4>No Output Yet</h4>
          <p>This workflow hasn't been executed yet. Output will appear here once the workflow runs.</p>
          <button type="button" class="btn btn-primary create-first-btn" @click="gotoWorkflowHomePage()">
            <i class="fa fa-arrow-left"></i> Back to Workflows
          </button>
        </div>

        <!-- Output Table -->
        <div v-if="workflowOutput && workflowOutput.length > 0" class="output-table-container">
          <!-- Table Header -->
          <div class="output-table-header">
            <div>Run ID</div>
            <div>Result</div>
            <div class="header-ran-on">Last Ran On</div>
            <div>Status</div>
          </div>

          <!-- Output Items -->
          <div
            class="output-item"
            v-for="(output, index) in workflowOutput"
            :key="index"
          >
            <!-- Run ID Column -->
            <div class="text-title-wrap">
              <i class="fa fa-play-circle output-icon" aria-hidden="true"></i>
              <div class="run-id-content">
                <span class="run-id-text" :title="output.WorkflowRunID">{{ truncateRunId(output.WorkflowRunID) }}</span>
                <button class="copy-btn" @click.stop="copyRunId(output.WorkflowRunID)" :title="'Copy full ID'">
                  <i class="fa fa-copy"></i>
                </button>
              </div>
            </div>

            <!-- Result Column -->
            <div class="result-column">
              <div class="result-content" v-html="output.Result"></div>
            </div>

            <!-- Last Ran On Column -->
            <div class="date-column ran-on-column" v-if="allSettings">
              {{ output.LastRanOn | dateformatwithtime(allSettings.GENERAL_TIMEZONE.PropertyValue) }}
            </div>

            <!-- Status Column -->
            <div class="status-column">
              <span class="status-badge success" v-if="output.Successful === 1">
                <i class="fa fa-check-circle"></i> Success
              </span>
              <span class="status-badge warning" v-else>
                <i class="fa fa-exclamation-triangle"></i> Warning
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import mixin from '../../mixin.js';

export default {
  name: "WorkflowOutput",
  components: { ErrorDisplay },
  props: ['workflowID'],
  mixins: [mixin],

  created() {
    this.init();
  },

  data() {
    return {
      workflowOutput: [],
    };
  },
  methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
    ...mapActions('workflow', ['getWorkflowOutput']),

    async init() {
        // siteID: the API only returns runs of workflows that belong to the signed-in user's site (request-auth 2026-10-20).
        this.workflowOutput = await this.getWorkflowOutput({WorkflowID: this.workflowID, siteID: this.siteID});
    },

    truncateRunId(runId) {
      if (!runId) return '';
      // Show first 8 chars of UUID
      return runId.substring(0, 8) + '...';
    },

    copyRunId(runId) {
      navigator.clipboard.writeText(runId).then(() => {
        this.$toast.success('Run ID copied to clipboard');
      }).catch(() => {
        this.$toast.error('Failed to copy Run ID');
      });
    },

    gotoCreatePage() {
      let routeData = this.$router.resolve({name: 'CreateWorkflow'});
      window.open(routeData.href, '_blank');
    },

    gotoWorkflowHomePage() {
      this.$router.push({ name: 'Workflow' });
    },

    gotoViewPage(workflowID) {
      let routeData = this.$router.resolve(
        {
          path: `workflow/${workflowID}`
        }
      );
      window.open(routeData.href, '_blank');
    },

  },

  computed: {
  }

};
</script>
<style src="./WorkflowOutput.scss" lang="scss" scoped></style>
